if (!customElements.get('early-access-code')) {
  customElements.define('early-access-code', class extends HTMLElement {
    connectedCallback() {
      if (this.onCopy) return;
      this.onCopy = async () => {
        const button = this.querySelector('[data-copy]');
        const status = this.querySelector('[data-status]');
        const code = this.querySelector('[data-code]').textContent;
        const label = button.textContent;
        button.disabled = true;
        try {
          await navigator.clipboard.writeText(code);
          button.textContent = button.dataset.success;
          status.textContent = button.dataset.success;
          this.resetTimer = setTimeout(() => { button.textContent = label; status.textContent = ''; }, 2000);
        } catch (error) {
          status.textContent = 'Please select and copy the code above.';
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('[data-code]'));
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } finally {
          button.disabled = false;
        }
      };
      this.querySelector('[data-copy]').addEventListener('click', this.onCopy);
    }
    disconnectedCallback() {
      clearTimeout(this.resetTimer);
      this.querySelector('[data-copy]').removeEventListener('click', this.onCopy);
      this.onCopy = null;
    }
  });
}
